import api from './axiosConfig';
import { handleApiError } from './errorHandler';

export const stockItemAPI = {
    create: async (stockItemData) => {
        try {
            const { data } = await api.post('/api/stock-items/create/', stockItemData);
            return data;
        } catch (error) {
            handleApiError(error, 'Create stock item error:');
        }
    },
    getAll: async (page, pageSize, searchTerm, manufacturerId, categoryIds, showDeactivated, manufactured, brandId, uom, sortColumn, sortDirection) => {
        try {
            const { data } = await api.get('/api/stock-items', {
                params: { page, pageSize, searchTerm, manufacturerId, categoryIds, showDeactivated, manufactured, brandId, uom, sortColumn, sortDirection }
            });
            return data;
        } catch (error) {
            handleApiError(error, 'Get all stock items error:');
        }
    },
    getById: async (id) => {
        try {
            const { data } = await api.get(`/api/stock-items/${id}`);
            return data;
        } catch (error) {
            handleApiError(error, 'Get stock item by id error:');
        }
    },
    update: async (id, stockItemData) => {
        try {
            const { data } = await api.put(`/api/stock-items/update/${id}/`, stockItemData);
            return data;
        } catch (error) {
            handleApiError(error, 'Update stock item error:');
        }
    },
    delete: async (id) => {
        try {
            const { data } = await api.delete(`/api/stock-items/delete/${id}/`);
            return data;
        } catch (error) {
            handleApiError(error, 'Delete stock item error:');
        }
    },
    getOutOfStock: async (page, pageSize, periodDays = 90, searchTerm = '', manufactured) => {
        try {
            const { data } = await api.get('/api/out-of-stock-items/', {
                params: { page, pageSize, period_days: periodDays, searchTerm, manufactured }
            });
            return data;
        } catch (error) {
            handleApiError(error, 'Get out of stock items error:');
        }
    },
    getAlmostOutOfStock: async (page, pageSize, searchTerm = '', manufactured) => {
        try {
            const { data } = await api.get('/api/almost-out-of-stock-items/', {
                params: { page, pageSize, searchTerm, manufactured }
            });
            return data;
        } catch (error) {
            handleApiError(error, 'Get almost out of stock items error:');
        }
    },
    getCostHistory: async (stockItemId) => {
        try {
            const { data } = await api.get(`/api/stock-items/${stockItemId}/cost-history/`);
            return data;
        } catch (error) {
            handleApiError(error, 'Get cost history error:');
        }
    },
    generateStockItemsReport: async (searchTerm, manufacturerId, categoryIds, showDeactivated, fileType, columns) => {
        try {
            const response = await api.get('/api/reports/stock-items/', {
                params: {
                    searchTerm,
                    manufacturerId,
                    categoryIds,
                    showDeactivated,
                    fileType,
                    columns
                },
                responseType: 'blob'
            });

            const url = window.URL.createObjectURL(new Blob([response.data]));
            const link = document.createElement('a');
            link.href = url;

            const timestamp = new Date().toISOString().replace(/[:.]/g, '-').slice(0, -5);
            const extension = fileType === 'pdf' ? 'pdf' : 'csv';
            link.setAttribute('download', `stock_items_report_${timestamp}.${extension}`);

            document.body.appendChild(link);
            link.click();
            link.remove();
            window.URL.revokeObjectURL(url);

            return true;
        } catch (error) {
            handleApiError(error, 'Generate stock items report error:');
            return false;
        }
    }
};